<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row justify="space-between">
          <el-col :span="22">
            <el-form
              size="medium"
              :inline="true"
              :model="searchCondition"
              class="demo-form-inline"
            >
              <el-form-item label="时间">
                <DatePicker @dataSearch="dataSearch" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchButton">查询</el-button>
              </el-form-item>
            </el-form>
          </el-col>

          <el-col :span="1">
            <el-button
              type="primary"
              size="medium"
              icon="iconfont"
              @click="addPosition"
              >发布岗位</el-button
            >
          </el-col>
        </el-row>
        <ApeTable
          ref="apeTable"
          :data="dataList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
        <el-table-column slot="second-column" align="center" label="岗位名称">
            <template slot-scope="scope">
              <div class="text-ellipsis">
                {{ scope.row.recruit_post }}
              </div>
            </template>
          </el-table-column>
          <el-table-column slot="second-column" align="center" label="企业标签">
            <template slot-scope="scope">
              <el-tooltip effect="dark" :content="scope.row.recruit_tag_label" placement="top-start" popper-class="ape-table-tooltip">
                <div class="text-ellipsis">
                {{ scope.row.recruit_tag_label }}
              </div>
                </el-tooltip>
              
            </template>
          </el-table-column>
          <el-table-column slot="second-column" align="center" label="行业类型">
            <template slot-scope="scope">
              <el-tooltip effect="dark" :content="scope.row.recruit_industry_label" placement="top-start" popper-class="ape-table-tooltip">
                <div class="text-ellipsis">
                {{ scope.row.recruit_industry_label }} </div>
              </el-tooltip>
              
            </template>
          </el-table-column>
          <el-table-column align="center" label="报名人数">
            <template slot-scope="scope">
              <div
                style="color:#1890ff;cursor: pointer;"
                @click="goBaoming(scope.row)"
              >
                {{ scope.row.apply_count }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态">
            <template slot-scope="scope">
              <div>{{ status_text[scope.row.show_status] }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <span>
                <el-button type="infor" size="mini" @click="toView(scope.row)"
                  >详情</el-button
                >
                <el-popover placement="top" v-model="scope.row.visible">
                  <p>确定要修改状态吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini"
                               @click="checkUpload(scope.row.status, scope.row.id)">确定</el-button>
                  </div>
                  <el-button
                    size="mini"
                    :type="scope.row.status == 1 ? 'danger' : 'primary'"
                    slot="reference"
                  >{{ scope.row.status == 1 ? '关闭' : '开启' }}</el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
  },
  data() {
    return {
      loadingStaus: false,
      // 搜索条件
      searchCondition: {},
      //任务列表
      dataList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      status_text: ["未开始", "进行中", "已完成", "已暂停"],
      work_text: ["", "全职", "兼职", "实习"],
      degree_rext: ["不限", "小学", "初中", "高中", "大专", "本科及以上"],
      columns: [
        {
          title: "用工人数",
          value: "worked_num",
          header_align: "center",
          align: "center",
        },
        {
          title: "年龄要求",
          value: "ageScope",
          header_align: "center",
          align: "center",
        },
        {
          title: "学历要求",
          value: "degreeScope",
          header_align: "center",
          align: "center",
        },
        {
          title: "工作地点",
          value: "address",
          header_align: "center",
          align: "center",
        },
        {
          title: "联系人电话",
          value: "contact_number",
          header_align: "center",
          align: "center",
        },
        {
          title: "薪资范围",
          value: "salaryScope",
          header_align: "center",
          align: "center",
        },
        {
          title: "工作性质",
          value: "workScope",
          header_align: "center",
          align: "center",
        },
      ],
      visible: false,
      innerVisible: false,
      OrImage: "",
      tabContent: "",
      tabType: 1,
    };
  },
  computed: {},
  watch: {
    "$route.matched": function(n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
    visible: function(v) {
      console.log("visible", v);
    },
  },
  methods: {
    async checkUpload(status, id) {
      var missionStatus;
      if (status == 1) {
        missionStatus = 0
      }
      if (status == 0) {
        missionStatus = 1
      }
      let args = {
        status: missionStatus,
        id
      }
      let res = await this.$api.updateDailyPost(args)
      if (res) {
        this.init()
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 初始化
    async init(type) {
      this.loadingStaus = false;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "export") {
        pagingInfo.page_size = 50000;
      } else {
        this.loadingStaus = true;
      }
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let { data, pages } = await this.$api.getDailyPostList(searchCondition);
      this.dataList = data.map((item) => {
        item.salaryScope = item.min_salary + " - " + item.max_salary;
        item.ageScope = item.min_age + " - " + item.max_age;
        item.degreeScope = this.degree_rext[item.education];
        item.workScope = this.work_text[item.work_type];
        item.recruit_tag_label = item.recruit_tag
          .map((tag) => tag.tag_name)
          ?.join(",");
        item.recruit_industry_label = item.recruit_industry
          .map((tag) => tag.industry_type_name)
          ?.join(",");
        return item;
      });
      if (type == "export") {
        return data;
      } else {
        this.dataList = data;
        this.pagingData.total = pages.total;
        this.offset = pages.offset;
        this.loadingStaus = false;
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.outer_trade_no) {
        condition.outer_trade_no = this.searchCondition.outer_trade_no;
      }
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name;
      }
      if (this.searchCondition.time_value) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        };
      }
      return condition;
    },
    showMissionContent(content) {
      this.tabType = 2;
      this.tabContent = content;
      this.innerVisible = true;
    },
    goBaoming(row) {
      console.log(row);
      this.$router.push({
        path: "/position/registrationList",
        query: { post_id: row.id },
      });
    },
    // 跳转详情页面
    toView(row) {
      this.$router.push({
        path: "/position/create",
        query: { id: row.id, type: "details" },
      });
    },
    // 发布岗位
    addPosition() {
      this.$router.push({ path: "/position/create", params: {} });
    },
  },

  created() {},
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 3;
}
</style>
